<template>
  <button
    class="arc-button"
    :class="{outline:outline,white:white,narrow:narrow,primary:primary,widthStretch:widthStretch,narrowHeight:narrowHeight,lightBlue:lightBlue,smallButton:smallButton,mediumButton:mediumButton,normalWidth:normalWidth}"
    @click.stop="onclick()"
  >
    <i
      v-if="leadingIcon"
      :class="leadingIcon"
    />
    <p>{{ textLabel }}</p>
  </button>
</template>
<script>
export default {
  name: "ArcButton",
  props: {
    textLabel: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    widthStretch: {
      type: Boolean,
      default: false,
    },
    narrowHeight: {
      type: Boolean,
      default: false,
    },
    lightBlue: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 44,
    },
    smallButton: {
      type: Boolean,
      default: false,
    },
    mediumButton: {
      type: Boolean,
      default: false,
    },
    normalWidth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped >
.arc-button {
  @include ts;
  @include flex_center;
  position: relative;
  padding: 0 24px;
  height: 44px;
  border-radius: 28px;
  white-space: nowrap;
  border: 1px solid var(--white);
  &.narrowHeight {
    height: 36px;
  }
  &.widthStretch {
    width: 100%;
  }
  &.narrow {
    width: 180px;
  }
  &.normalWidth {
    width: 200px;
  }
  &.outline {
    border: 1px solid var(--gray-500);
    p {
      color: var(--gray-700);
    }
    i {
      color: var(--gray-700);
    }
    &:hover {
      border: solid 1px var(--blue-500);
      background-color: #f5fbff;
      p,
      i {
        color: var(--blue-500);
      }
    }
    &:active {
      border: solid 1px var(--blue-500);
      background-color: #e3f1fc;
      p,
      i {
        color: var(--blue-700);
      }
    }
  }
  &.primary {
    border: 1px solid var(--blue-500);
    background-color: var(--white);
    p {
      color: var(--blue-500);
    }
    i {
      color: var(--blue-500);
    }
    &:hover {
      background-color: var(--blue-500);
      p,
      i {
        color: var(--white);
      }
    }
    &:active {
      background-color: var(--blue-700);
      p,
      i {
        color: var(--white);
      }
    }
  }
  &.lightBlue {
    background-color: var(--blue-10);
    p,
    i {
      color: var(--blue-500);
    }
    &:hover {
      background-color: var(--blue-30);
    }
  }
  &.white {
    background-color: var(--white);
    p,
    i {
      color: var(--blue-500);
    }
  }
  &.smallButton {
    width: 74px;
  }
  &.mediumButton {
    width: 108px;
  }
  p {
    position: relative;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 1px;
    text-align: center;
    color: var(--white);
  }
  i {
    position: relative;
    margin-right: 12px;
    font-size: 20px;
    color: white;
  }
}
</style>